import { useEffect, useState } from "react";
import { ordersAnalyticsApi } from "@/features/orders-analytics/api/orders-analytics.api";
import {
    OrdersAnalyticsFilters,
    SenderProfileResponse,
} from "@/features/orders-analytics/types/orders-analytics.types";

export function useSenderProfile(filters: OrdersAnalyticsFilters) {
    const [data, setData] = useState<SenderProfileResponse | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);

        ordersAnalyticsApi
            .fetchSenderProfile(filters)
            .then((response) => {
                if (cancelled) return;
                setData(response);
            })
            .catch((reason: unknown) => {
                if (cancelled) return;
                setError(reason instanceof Error ? reason.message : "Unknown error");
            })
            .finally(() => {
                if (cancelled) return;
                setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [filters]);

    return { data, loading, error };
}
